import { useTranslation } from '@mint-lib/i18n';
import { typographyVariants } from '@mint-lib/tw-components';
import { getRouteApi, Link } from '@mint/routing';

const routerApi = getRouteApi(
  '/_secured/campaign/$campaignId/planning/buying-plan',
);

export const ArchivedVersionNotice = () => {
  const { t } = useTranslation('@myn/planning_v2');

  const { flightVersionId: _removed, ...updatedSearch } = routerApi.useSearch();

  return (
    <div className="ml-4 flex items-center gap-0.5">
      <p
        className={typographyVariants({
          variant: 'caption1',
          color: 'secondary',
        })}
      >
        {t('This is an archive version.')}
      </p>

      <Link
        to="."
        search={updatedSearch}
        data-dd-action-name="Archived version notice: back to current version"
        className={typographyVariants({
          variant: 'caption1',
          color: 'link',
        })}
      >
        {t('Back to current version')}
      </Link>
    </div>
  );
};
